// extracted by mini-css-extract-plugin
export default {"footer_Component":"Footer_footer_Component__PS9nX"};